import React from 'react';
import clsx from 'clsx';

import { MHighlightIconProps, MHighlightIconAlignment } from './MHighlightIcon.types';
import * as Styled from './MHighlightIcon.styles';
import { AIcon } from '../../atoms/AIcon/index';
import { ABody } from '../../atoms/ABody/index';
import { ASubheader } from '../../atoms/ASubheader/index';
import { MButton } from '../MButton/index';

const COMPONENT_NAME = 'm-web-ui-kit-MHighlightIcon';
const TEST_ID = 'web-ui-kit-MHighlightIcon';

export function MHighlightIcon({
  alignment = MHighlightIconAlignment.Centered,
  showCTA = true,
  aIcon,
  aSubheader,
  aBody,
  mButton,
}: MHighlightIconProps) {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} alignment={alignment}>
      <AIcon {...aIcon} className={clsx('a-icon-branded', aIcon.className)} />
      <div>
        <ASubheader {...aSubheader} />
        {aBody?.bodyText && <ABody {...aBody} bodyText={aBody.bodyText} />}
      </div>
      {showCTA && mButton?.buttonText && <MButton {...mButton} />}
    </Styled.Wrapper>
  );
}

export { MHighlightIconAlignment };
export type { MHighlightIconProps };
